export const DOC_LEVELS = ['VIEWER', 'COMMENTER', 'EDITOR', 'MANAGER', 'ADMIN'] as const

export const LEVEL_RANK: Record<string, number> = {
  VIEWER: 1,
  COMMENTER: 2,
  EDITOR: 3,
  MANAGER: 4,
  ADMIN: 5,
}

export const levelAtLeast = (level: string | null | undefined, min: string): boolean =>
  !!level && LEVEL_RANK[level] >= LEVEL_RANK[min]
